import { Quartile, QuartileRange, QuartileRanges } from '../interfaces';

/**
 * Determines what quartile the value belongs into based on preset values for quartile ranges.
 *
 * @param percent the value to check the ranges against, ensure it's between 0 and 1
 */
export function determineQuartileByPercent(percent: number): Quartile {
	if (percent <= QuartileRange.One) return 1;
	if (percent <= QuartileRange.Two) return 2;
	if (percent <= QuartileRange.Three) return 3;
	return 4;
}

/**
 * use this as inclusive of max, exclusive of min.
 *
 * @example
 * value > min
 * value <= max
 */
export const QuartileThresholdMap: {
	[key in Quartile]: { min: number; max: number };
} = {
	1: { min: 0, max: QuartileRange.One },
	2: { min: QuartileRange.One, max: QuartileRange.Two },
	3: { min: QuartileRange.Two, max: QuartileRange.Three },
	4: { min: QuartileRange.Three, max: QuartileRange.Four },
};

export const defaultQuartileRanges = (): QuartileRanges => ({
	1: 0,
	2: 0,
	3: 0,
	4: 0,
});
